import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, withState, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import ValidationText from '../../components/atoms/ValidationText';
import { addGiftCard } from '../../actions/GiftCard';
import CancelButton from '../../components/atoms/CancelButton';
import RegisterButton from '../../components/atoms/RegisterButton';
import { sendLogin } from '../../auth/Auth';

const styles = theme => ({
  root: {
    position: 'absolute',
    width: '60%',
    height: '92%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    outline: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      padding: 16
    }
  },
  pageTitle: {
    marginBottom: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      marginBottom: 10
    }
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 5px'
    },
    display: 'flex',
    flexDirection: 'column',
    height: '85%',
    overflowY: 'scroll'
  },
  delete: {
    // display: 'none',
    position: 'absolute',
    top: 0,
    right: 0,
    color: 'red'
  },
  topActions: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  menuPaper: {
    top: '190px !important'
  },
  cardWrap: {
    height: 300,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  formControl: {
    width: '100%'
  },
  textField: {
    width: '100%'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    () => {},
    dispatch => ({
      actions: bindActionCreators({ addGiftCard }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('openAddProgress', 'updateOpenAddProgress', false),
  withState('loading', 'updateLoading', false),
  withState('imagesList', 'setImagesList', []),
  withState('imagesListPreview', 'setImagesListPreview', []),
  withState('categories', 'setCategories', []),
  withState('resultMessage', 'setResultMessage', ''),
  withState('openProgress', 'updateOpenProgress', false),
  withState('connectSystemId', 'setConnectSystemId', ''),
  withState('connectSystemName', 'setConnectSystemName', ''),
  withState('connectSystemAddress', 'setConnectSystemAddress', ''),
  withState('connectSystemEmail', 'setConnectSystemEmail', ''),
  withState('domainUrl', 'setDomainUrl', ''),
  withState('webDomainUrl', 'setWebDomainUrl', ''),
  withState('userWebDomainUrl', 'setUserWebDomainUrl', ''),
  withState('companyPostalCode', 'setCompanyPostalCode', ''),
  withState('connectSystemShortName', 'setConnectSystemShortName', ''),
  withState('preDomain', 'setPreDomain', ''),
  withState('connectSystemIdError', 'setConnectSystemIdError', ''),
  withState('connectSystemNameError', 'setConnectSystemNameError', ''),
  withState('connectSystemAddressError', 'setConnectSystemAddressError', ''),
  withState('connectSystemEmailError', 'setConnectSystemEmailError', ''),
  withState('domainUrlError', 'setDomainUrlError', ''),
  withState('webDomainUrlError', 'setWebDomainUrlError', ''),
  withState('userWebDomainUrlError', 'setUserWebDomainUrlError', ''),
  withState('companyPostalCodeError', 'setCompanyPostalCodeError', ''),
  withState(
    'connectSystemShortNameError',
    'setConnectSystemShortNameError',
    ''
  ),
  withState('preDomainError', 'setPreDomainError', ''),

  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  })
  // lifecycle({
  //   componentDidMount() {}
  // })
);

const Main = enhance(
  ({
    classes,
    cancelAction,
    addNewShashoku,
    connectSystemId,
    setConnectSystemId,
    connectSystemName,
    setConnectSystemName,
    connectSystemAddress,
    setConnectSystemAddress,
    connectSystemEmail,
    setConnectSystemEmail,
    domainUrl,
    setDomainUrl,
    webDomainUrl,
    setWebDomainUrl,
    userWebDomainUrl,
    setUserWebDomainUrl,
    companyPostalCode,
    setCompanyPostalCode,
    connectSystemShortName,
    setConnectSystemShortName,
    preDomain,
    setPreDomain,
    connectSystemIdError,
    setConnectSystemIdError,
    connectSystemNameError,
    setConnectSystemNameError,
    connectSystemAddressError,
    setConnectSystemAddressError,
    connectSystemEmailError,
    setConnectSystemEmailError,
    domainUrlError,
    setDomainUrlError,
    webDomainUrlError,
    setWebDomainUrlError,
    userWebDomainUrlError,
    setUserWebDomainUrlError,
    companyPostalCodeError,
    setCompanyPostalCodeError,
    connectSystemShortNameError,
    setConnectSystemShortNameError,
    preDomainError,
    setPreDomainError
  }) => {
    const errors = {
      connectSystemIdError,
      connectSystemNameError,
      connectSystemAddressError,
      connectSystemEmailError,
      domainUrlError,
      webDomainUrlError,
      userWebDomainUrlError,
      companyPostalCodeError,
      connectSystemShortNameError,
      preDomainError
    };

    const validConnectSystemIdError = () => {
      if (!connectSystemId) {
        setConnectSystemIdError('必須項目です。');
        return 1;
      }
      setConnectSystemIdError('');
      return 0;
    };
    const validConnectSystemNameError = () => {
      if (!connectSystemName) {
        setConnectSystemNameError('必須項目です。');
        return 1;
      }
      setConnectSystemNameError('');
      return 0;
    };
    const validConnectSystemAddressError = () => {
      if (!connectSystemAddress) {
        setConnectSystemAddressError('必須項目です。');
        return 1;
      }
      setConnectSystemAddressError('');
      return 0;
    };
    const validConnectSystemEmailError = () => {
      if (!connectSystemEmail) {
        setConnectSystemEmailError('必須項目です。');
        return 1;
      }
      setConnectSystemEmailError('');
      return 0;
    };
    const validDomainUrlError = () => {
      if (!domainUrl) {
        setDomainUrlError('必須項目です。');
        return 1;
      }
      setDomainUrlError('');
      return 0;
    };
    const validWebDomainUrlError = () => {
      if (!webDomainUrl) {
        setWebDomainUrlError('必須項目です。');
        return 1;
      }
      setWebDomainUrlError('');
      return 0;
    };
    const validUserWebDomainUrlError = () => {
      if (!userWebDomainUrl) {
        setUserWebDomainUrlError('必須項目です。');
        return 1;
      }
      setUserWebDomainUrlError('');
      return 0;
    };
    const validCompanyPostalCodeError = () => {
      if (!companyPostalCode) {
        setCompanyPostalCodeError('必須項目です。');
        return 1;
      }
      setCompanyPostalCodeError('');
      return 0;
    };
    const validConnectSystemShortNameError = () => {
      if (!connectSystemShortName) {
        setConnectSystemShortNameError('必須項目です。');
        return 1;
      }
      setConnectSystemShortNameError('');
      return 0;
    };
    const validPreDomainError = () => {
      if (!preDomain) {
        setPreDomainError('必須項目です。');
        return 1;
      }
      setPreDomainError('');
      return 0;
    };

    const valid = () => {
      const errorCount =
        validConnectSystemIdError() +
        validConnectSystemNameError() +
        validConnectSystemAddressError() +
        validConnectSystemEmailError() +
        validDomainUrlError() +
        validWebDomainUrlError() +
        validUserWebDomainUrlError() +
        validCompanyPostalCodeError() +
        validConnectSystemShortNameError() +
        validPreDomainError();
      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const registerAction = async () => {
      const param = {
        connectSystemId,
        connectSystemName,
        connectSystemAddress,
        connectSystemEmail,
        domainUrl,
        webDomainUrl,
        userWebDomainUrl,
        companyPostalCode,
        connectSystemShortName,
        preDomain
      };
      if (!valid()) {
        alert('登録情報を正しく入力してください。');
      } else {
        addNewShashoku(param);
      }
    };

    return (
      <div className={classes.root}>
        <div className={classes.pageTitle}>
          <Typography variant="h6">ADD NEW BIZMESHI</Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.topActions}>
            <FormControl className={classes.formControl}>
              <TextField
                required
                fullWidth
                label="connectSystemId"
                className={classes.textField}
                margin="normal"
                value={connectSystemId}
                name="connectSystemId"
                onChange={e => {
                  setConnectSystemId(e.target.value);
                }}
              />
              <ValidationText message={errors.connectSystemIdError} />
              <TextField
                required
                fullWidth
                label="connectSystemName"
                className={classes.textField}
                margin="normal"
                value={connectSystemName}
                name="connectSystemName"
                onChange={e => {
                  setConnectSystemName(e.target.value);
                }}
              />
              <ValidationText message={errors.connectSystemNameError} />
              <TextField
                required
                fullWidth
                label="connectSystemAddress"
                className={classes.textField}
                margin="normal"
                value={connectSystemAddress}
                name="connectSystemAddress"
                onChange={e => {
                  setConnectSystemAddress(e.target.value);
                }}
              />
              <ValidationText message={errors.connectSystemAddressError} />
              <TextField
                required
                fullWidth
                label="connectSystemEmail"
                className={classes.textField}
                margin="normal"
                value={connectSystemEmail}
                name="connectSystemEmail"
                onChange={e => {
                  setConnectSystemEmail(e.target.value);
                }}
              />
              <ValidationText message={errors.connectSystemEmailError} />
              <TextField
                required
                fullWidth
                label="domainUrl"
                className={classes.textField}
                margin="normal"
                value={domainUrl}
                name="domainUrl"
                onChange={e => {
                  setDomainUrl(e.target.value);
                }}
              />
              <ValidationText message={errors.domainUrlError} />
              <TextField
                required
                fullWidth
                label="adminDomainURL"
                className={classes.textField}
                margin="normal"
                value={webDomainUrl}
                name="webDomainUrl"
                onChange={e => {
                  setWebDomainUrl(e.target.value);
                }}
              />
              <ValidationText message={errors.webDomainUrlError} />
              <TextField
                required
                fullWidth
                label="userWebDomainUrl"
                className={classes.textField}
                margin="normal"
                value={userWebDomainUrl}
                name="userWebDomainUrl"
                onChange={e => {
                  setUserWebDomainUrl(e.target.value);
                }}
              />
              <ValidationText message={errors.userWebDomainUrlError} />
              <TextField
                required
                fullWidth
                label="companyPostalCode"
                className={classes.textField}
                margin="normal"
                value={companyPostalCode}
                name="companyPostalCode"
                onChange={e => {
                  setCompanyPostalCode(e.target.value);
                }}
              />
              <ValidationText message={errors.companyPostalCodeError} />
              <TextField
                required
                fullWidth
                label="connectSystemShortName"
                className={classes.textField}
                margin="normal"
                value={connectSystemShortName}
                name="connectSystemShortName"
                onChange={e => {
                  setConnectSystemShortName(e.target.value);
                }}
              />
              <ValidationText message={errors.connectSystemShortNameError} />
              <TextField
                required
                fullWidth
                label="preDomain"
                className={classes.textField}
                margin="normal"
                value={preDomain}
                name="preDomain"
                onChange={e => {
                  setPreDomain(e.target.value);
                }}
              />
              <ValidationText message={errors.preDomainError} />
            </FormControl>
          </div>
        </Paper>
        <div>
          <CancelButton onClickAction={cancelAction} color="primary" />
          <RegisterButton onClickAction={registerAction} />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
